import { ErrorFallback } from "@/src/components/mobile/QueryNetworkBoundrary";
import { AHText, ListItem } from "arkh";
import React from "react";
import { FallbackProps } from "react-error-boundary";

export function ProductDetailsErrorFallback(props: {
  errorFallbackProps: FallbackProps;
  description?: string;
}) {
  return (
    <React.Fragment>
      {props.description ? (
        <ListItem>
          <AHText type="subtitle" color="text-secondary">
            {props.description}
          </AHText>
        </ListItem>
      ) : null}
      <ErrorFallback
        error={props.errorFallbackProps.error}
        resetErrorBoundary={props.errorFallbackProps.resetErrorBoundary}
      />
    </React.Fragment>
  );
}
